<template>
  <div class="error-state">
    <div class="error-icon">
      <svg width="56" height="56" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.6"/>
        <path d="M12 7V13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        <circle cx="12" cy="16.5" r="1.2" fill="currentColor"/>
      </svg>
    </div>
    <h3 class="error-title">{{ $t('error.title') }}</h3>
    <p class="error-desc">{{ $t('error.desc') }}</p>
    <button class="error-retry" @click="$emit('retry')">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style="vertical-align: -3px; margin-right: 6px;">
        <path d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C15.1733 4 17.9416 5.733 19.5 8.33333" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        <path d="M20 4V8.5H15.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      {{ $t('error.retry') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ErrorState',
  emits: ['retry']
}
</script>

<style scoped>
.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 55vh;
  padding: 60px 24px;
  text-align: center;
  background: #FFFFFF;
}

.error-icon {
  color: #E53935;
  margin-bottom: 20px;
  animation: errorShake 0.6s ease;
}

@keyframes errorShake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-6px); }
  50% { transform: translateX(6px); }
  75% { transform: translateX(-3px); }
}

.error-title {
  font-size: 24px;
  font-weight: 700;
  color: #1A1A1A;
  margin-bottom: 12px;
}

.error-desc {
  font-size: 15px;
  color: #9E9E9E;
  margin-bottom: 28px;
  max-width: 420px;
  line-height: 1.7;
}

.error-retry {
  display: inline-flex;
  align-items: center;
  background: #0B4F8C;
  color: #FFFFFF;
  border: none;
  border-radius: 40px;
  padding: 12px 32px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.error-retry:hover {
  background: #1565C0;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(11, 79, 140, 0.3);
}

@media (max-width: 480px) {
  .error-title {
    font-size: 20px;
  }
}
</style>
